function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';

    let telNumber = phoneNumber;

    if (phoneNumber.length > 3) {
        const replaceSymbols = telNumber.slice(0, telNumber.length - 3);
        const asteriskSymbols = new Array(replaceSymbols.length + 1).join('*');

        telNumber = `${asteriskSymbols}${phoneNumber.slice(phoneNumber.length - 3)}`
    }

    const arrNumber = telNumber.match(/.{1,3}/g);

    return arrNumber.reduce((acc, item) => {
        acc += ` ${item}`;
        return acc;
    }, '');
}

export {
    formatPhoneNumber
};